import { useCallback } from 'react'

import { authApi } from 'modules/auth/api'
import { useBroadcastAuth } from 'modules/auth/handlers/useBroadcastAuth'

import { useLogoutClear } from './useLogoutClear'

export const useLogout = () => {
  const { logoutClear } = useLogoutClear()
  const { broadcastLogout } = useBroadcastAuth()

  const logout = useCallback(() => {
    authApi.logoutInform()
    logoutClear()
    broadcastLogout()
  }, [logoutClear, broadcastLogout])

  return { logout }
}
